import React, { memo } from "react";
import { Button, Icon } from "investira.react.components";
import { BaseTemplate } from "../../components/templates";
import EntidadesList from "./EntidadesList";
import EntidadeAddDialog from "./EntidadeAddDialog";
import { useEntidadesContext } from "../../contexts/EntidadesContext";

const Entidades = memo(() => {
  const { state, actions } = useEntidadesContext();

  return (
    <BaseTemplate
      title="Entidades"
      maxWidth="lg"
      headerRenderActions={
        <Button
          variant="contained"
          color="primary"
          startIcon={<Icon color="secondary" iconName="parthenon" size={16} />}
          size="small"
          sx={{ px: 2 }}
          onClick={actions.handleNewEntidade}
        >
          Nova entidade
        </Button>
      }
    >
      <EntidadesList />

      {state.isDialogOpen && <EntidadeAddDialog />}
    </BaseTemplate>
  );
});

export default Entidades;
